import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const adminToken = localStorage.getItem("ndpl_admin_token");
  const playerToken = localStorage.getItem("ndpl_player_token");
  const url = cfg.url || "";
  const method = (cfg.method || "get").toLowerCase();
  const isAdminRoute = url.startsWith("/admin");
  // Admin-only mutations on shared routes (settings)
  const isAdminMutation = method !== "get" && (url.startsWith("/settings") || url.startsWith("/sponsors") || url.startsWith("/gallery") || url.startsWith("/teams") || url.startsWith("/matches"));
  if (isAdminRoute || isAdminMutation) {
    if (adminToken) cfg.headers.Authorization = `Bearer ${adminToken}`;
  } else if (playerToken) {
    cfg.headers.Authorization = `Bearer ${playerToken}`;
  } else if (adminToken) {
    cfg.headers.Authorization = `Bearer ${adminToken}`;
  }
  return cfg;
});

export const fileUrl = (fileId) => (fileId ? `${API}/files/${fileId}` : "");
